// extracted by mini-css-extract-plugin
export default {"glossaryCard":"glosaryCard_glossaryCard__Ey+Gv","title":"glosaryCard_title__dIH1v","text":"glosaryCard_text__8ANDh"};